import React from 'react';
import { Box } from '@mui/material';
import Text from 'global/components/text';
import { useScreen } from 'global/styles';
import { HeaderValue } from './styles';

export default function HeaderItem(props) {
  const { label, value, content, capitalize, showInMobile = true } = props;
  const { isMobile } = useScreen();
  let val = value;

  if (capitalize && typeof val === 'string' && val) {
    val = val.charAt(0).toUpperCase() + val.slice(1);
  }

  const hasContent = content !== undefined;
  const display = !showInMobile && isMobile ? 'none' : 'flex';

  return (
    <Box
      sx={{
        display: display,
        flexDirection: "column"
      }}>
      {label ? <Text type="label_small">{label}</Text> : null}
      {hasContent ? <HeaderValue>{content}</HeaderValue> : <HeaderValue as={Text}>{val}</HeaderValue>}
    </Box>
  );
}
